'use-client';
import SpotifyPlayer from '../../SpotifyPlayer';
import { WithConsentPolicy } from '../../../../ConsentPolicyWrapper/viewer/ConsentPolicyWrapper';

export default WithConsentPolicy(SpotifyPlayer, {
  componentConsentPolicy: { advertising: true },
});
